
<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div v-if='btns.add'>
          <ejs-dropdownbutton :items='addOption' iconCss='icon hero-icon hero-icon-add' :select='dropDownAdd'></ejs-dropdownbutton>
        </div>
        <div v-if='btns.pviList'>
          <button :title='$t("Pui.puiList")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClick("qryPuiByPvi")'>
            <span class="e-btn-icon icon hero-icon hero-icon-grouplist e-icons"></span>
          </button>
        </div>
        <div v-if='btns.mod'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-edit" :title='$t("LteUser.modify")' @click='buttonClick("mod")'/></div>
        <div v-if='btns.del'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-remove" :title='$t("LteUser.remove")' @click='buttonClick("del")'/></div>
        <div v-if='btns.qry'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-refresh" :title='$t("LteUser.refresh")' @click='buttonClick("qry")'/></div>
        <div class="e-toolbar-item e-separator" aria-disabled="false"></div>  
        <div v-if='btns.src' class="e-input-group" style="height:28px;">
          <input class="e-input" :placeholder='$t("Pvi.pviSearch")' v-model='searchString' @input='searchChange("chg")' >
        </div> 
        <div v-if='btns.src'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-search" :title='$t("LteUser.search")' @click='buttonClick("src")'/></div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'PviTableMenu',
  data() {
    return {
      searchString: "",
      btns: {
        src: true,
        add: true,
        mod: true,
        del: true,
        qry: true,
        pviList: true,
      },
      addOption: [
        {
          text: this.$t("Pvi.addPvi"),
          value: 0
        },
        {
          text: this.$t("Pvi.addBatchPvi"),
          value: 1
        }],
    };
  },
  methods: {
    buttonClick(event) {
      this.$emit('methodEnum', event);
    },
    searchChange(event) {
      this.$emit('methodEnum', event, this.searchString);      
    },
    dropDownAdd(args) {
      if (args.item.value === 0) {
        this.$emit('methodEnum', 'add');
      } else if (args.item.value === 1) {
        this.$emit('methodEnum', 'addBatch');
      }
    },
        setSearchString() {
      this.searchString = '';
    }
  }
};
</script>

<style scoped>

</style>
